import { createSlice } from '@reduxjs/toolkit';
import { PREFERRED_COMMUNICATION_METHOD } from 'config/app-config';

export const initialState = {
  isLoading: false,
  errors: null,
  details: {
    title: null,
    firstName: null,
    lastName: null,
    birthDate: null,
    email: null,
    phoneNumber: null,
    phoneType: null,
    isChangeOfTenancy: null,
    isChangeOfName: false,
    relationshipToProperty: null,
    preferredCommunicationMethod: PREFERRED_COMMUNICATION_METHOD.EMAIL
  },
  data: {}
};

export const slice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setInitialState: (state) => {
      Object.entries(initialState).forEach(
        ([key, value]) => (state[key] = value)
      );
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = {};
      state.errors = payload;
    },
    setAccountField: (state, { payload: { name, value } }) => {
      state.details[name] = value;
    }
  }
});

export const {
  setInitialState,
  setAccountField,
  setSuccess,
  setError,
  setIsLoading
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectDetails = (state) => selectSlice(state).details;
export const selectIsLoading = (state) => selectSlice(state).isLoading;
export const selectErrors = (state) => selectSlice(state).errors;
export const selectData = (state) => selectSlice(state).data;

export default slice.reducer;
